import React, { useState, useEffect, useContext } from 'react';
import LayautContext from 'Context/ContextLayaut';
import { makeStyles, styled } from '@mui/styles';
import AvisoConfirmacion from 'ui-component/AvisoConfirmacion';
import {
    Box,
    Typography,
    colors,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Grid,
    Slide,
    Button,
    Stack,
    Autocomplete,
    TextField
} from '@mui/material';
import { School, GroupAdd } from '@mui/icons-material';
import { Tabla } from 'ui-component';
import Divider from '@mui/material/Divider';

import Services from './services';
import headers from './headers';

const useStyles = makeStyles((theme) => ({
    paper: {
        textAlign: 'center'
    },
    cancelar: {
        color: colors.blue[500]
    },
    aceptar: {
        color: colors.green[500]
    },
    remove: {
        color: colors.red[500]
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto'
        }
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        color: 'white'
    },
    inputRoot: {
        color: 'inherit'
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        color: 'white',
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        borderRadius: '10px',
        width: '0',
        '&:focus': {
            width: '20ch'
        }
    },
    activo: {
        width: '20ch'
    },
    iconButton: {
        color: 'white',
        backgroundColor: theme.palette.blue.main,
        borderRadius: '10px',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto'
        },
        '&:hover': {
            backgroundColor: theme.palette.blue.light,
            color: 'white'
        }
    }
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const ActividadTrainer = ({ open, title, data, cerrar, setTabla, tabla, cancel, updatesetPersonal, ...props }) => {
    const classes = useStyles();
    const services = Services();
    const context = useContext(LayautContext);
    // const [cursosTrainer, setCursosTrainer] = React.useState({ cursos: [] });
    const [sesionTrainer, setSesionTrainer] = React.useState({ sesion: [] });
    const [confirm, setConfirm] = useState({ open: false });
    const [index, setIndex] = React.useState(1);
    const [actividades, setActividades] = React.useState([]);

    // Functions
    const getActividades = () => {
        const row = data?.row;
        services.getActividades(
            (res) => {
                setActividades(res.actividades);
            },
            { idSesion: row?.idSesion, idColaborador: data.idColaborador }
        );
    };
    // const actualizarData = (nuevaSesion) => {
    //     const datausuario = actividades?.map((oc) => oc.idActividad);
    //     nuevaSesion.forEach((actividad) => {
    //         const indice = datausuario.indexOf(actividad.idActividad);
    //         if (indice >= 0) actividades?.splice(indice, 1, actividad);
    //         else actividades?.splice(0, 0, actividad);
    //     });
    //     setActividades([...actividades]);
    // };

    const actualizarDataTabla = (nuevaCurso) => {
        let colab = 0;
        const datausuario = tabla.map((oc) => oc.idpersona);
        nuevaCurso.forEach((sesionI) => {
            const indice = datausuario.indexOf(sesionI.idpersona);
            if (indice >= 0) tabla.splice(indice, 1, sesionI);
            else tabla.splice(0, 0, sesionI);
            colab = sesionI.idColaborador;
        });
        setTabla({ personal: [...tabla] });
        data.persona.idColaborador = colab;
    };

    const cambioTab = (event, newValue) => {
        if (newValue === null || newValue === 'undefined') {
            return 0;
        }
        services.getContenido(
            (res) => {
                setSesionTrainer({ sesion: res.sesion });
                if (res?.data != null) {
                    actualizarDataTabla(res?.data);
                }
            },
            {
                idCurso: newValue.idCurso,
                idColaborador: data?.persona?.idColaborador,
                idpersona: data?.persona?.idpersona,
                idcontrato: data?.persona?.idcontrato
            }
        );
        return 0;
    };

    // const cerrar = () => {
    //     const cont = index + 1;
    //     setIndex(cont);
    //     // setCursosTrainer({ cursos: [] });
    //     setSesionTrainer({ sesion: [] });
    //     cancel();
    // };

    const cambiarEstatusActividad = (actividad) => (e) => {
        let status = 1;
        if (actividad.estatus === '1') {
            status = 0;
        }

        services.cambiarEstatusActividad(
            (nuevaData) => {
                setActividades(nuevaData);
            },
            {
                estatus: status,
                idActividadColab: actividad.idActividadColab,
                idColaborador: data?.idColaborador,
                idActividad: actividad.idActividad,
                idSesion: actividad.idSesion
            }
        );
    };

    // Services
    // const getInfoInicial = () => {
    //     services.getCursos((res) => {
    //         setCursosTrainer({ cursos: res });
    //     });
    // };

    const cargarFunciones = () => {
        // getInfoInicial();
        getActividades();
    };

    useEffect(() => {
        if (open) {
            cargarFunciones();
        } else {
            setActividades([]);
        }
    }, [open]);

    return (
        <div>
            <Dialog
                open={open}
                maxWidth="lg"
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {data.withLeader == 1 && (
                        <Typography variant="h4" gutterBottom component="div">
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                {data?.row?.nombre_persona}
                                <School color="secondary" style={{ paddingBottom: '5px' }} />
                            </div>
                        </Typography>
                    )}
                    <br />
                    <Grid container spacing={2}>
                        {/* <Grid item xs={12}>
                            <div>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: 'fit-content',
                                        border: (theme) => `1px solid ${theme.palette.divider}`,
                                        borderRadius: 1,
                                        bgcolor: 'background.paper',
                                        color: 'text.secondary',
                                        '& svg': {
                                            m: 1.5
                                        },
                                        '& hr': {
                                            mx: 0.5
                                        }
                                    }}
                                >
                                    <Typography variant="h4" gutterBottom component="div">
                                        {data?.persona?.nombre_persona}
                                    </Typography>
                                    <Divider orientation="vertical" flexItem />
                                    <Typography variant="h4" gutterBottom component="div">
                                        {data?.persona?.nom_puesto}
                                    </Typography>
                                    <Divider orientation="vertical" flexItem />
                                    <Typography variant="h4" gutterBottom component="div">
                                        {data?.persona?.nom_sede}
                                    </Typography>
                                </Box>
                            </div>
                        </Grid> */}
                        {/* <Grid item xs={12}>
                            <div className={classes.divGrupoAlumnos}>
                                <br />
                                <Stack direction="row" alignItems="center" spacing={2}>
                                    <Autocomplete
                                        disablePortal
                                        key={`nivel_${index}`}
                                        id="combo-box-demo"
                                        options={cursosTrainer?.cursos}
                                        onChange={cambioTab}
                                        sx={{ width: 250 }}
                                        renderOption={(props, option) => (
                                            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                                {option.label}
                                            </Box>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Curso" key={`nivel_${index}`} />}
                                    />
                                </Stack>
                            </div>
                        </Grid> */}
                        <Grid item xs={12}>
                            <Tabla rows={actividades} columns={headers(cambiarEstatusActividad).actividad} columnKey="numSesion" />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className={classes.cancelar} onClick={cerrar}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
            <AvisoConfirmacion
                open={confirm.open}
                title="Advertencia"
                text={confirm.text}
                accept={confirm.aceptar}
                cancel={() => setConfirm({ open: false })}
            />
        </div>
    );
};

export default ActividadTrainer;
